import { render, staticRenderFns } from "./EndurancePage.vue?vue&type=template&id=07d62a42&"
import script from "./EndurancePage.vue?vue&type=script&lang=js&"
export * from "./EndurancePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports